export default {
	profile: {
		tabs: { perfil: 'Perfil', info: 'Informações', security: 'Segurança' },
		themeLight: 'Tema claro',
		language: 'Idioma',
		logout: 'Sair',
		save: 'Salvar',
		emails: 'E-mails',
		phones: 'Telefones',
		addEmail: '+ Adicionar e-mail',
		addPhone: '+ Adicionar telefone',
		currentPassword: 'Senha atual',
		newPassword: 'Nova senha',
		confirmPassword: 'Confirmar nova senha',
		changePassword: 'Alterar senha',
		cancel: 'Cancelar',
		fillAllFields: 'Preencher todos os campos',
		passwordMismatch: 'As novas senhas não coincidem',
		photoUpdated: 'Foto atualizada',
		photoError: 'Erro ao enviar a foto',
		infoUpdated: 'Informações atualizadas',
		infoError: 'Erro ao atualizar informações',
		passwordUpdated: 'Senha atualizada',
		passwordError: 'Erro ao alterar senha',
		themeError: 'Erro ao alterar o tema',
		languageUpdated: 'Idioma atualizado',
		languageError: 'Erro ao alterar o idioma',
		name: 'Nome',
	},
};
